import * as React from 'react';
import { UIHeading3, Button, UIText2 } from '@cian/ui-kit';

import * as styles from './styles.css';
import { IHouseStats } from '../../../../types/newbuilding/genplan';
import { EscrowLabel } from '../../../Labels';
import { SalesStartLabel } from '../../../SalesStartLabel';
import { HouseStats } from '../HouseStats';

interface IHouseTooltipProps {
  name: string;
  houseId: number;
  houseInfo: string[];
  stats: IHouseStats | null;
  isEscrow: boolean;
  isSalesStart?: boolean;
  isFloorPlanEnabled: boolean;
  onFloorPlanClick(): void;
  onLinkClick(houseId: number, rooms?: string): void;
  onEscrowLabelClick(event: React.MouseEvent<HTMLElement>): void;
}

export function HouseTooltip({
  name,
  houseId,
  houseInfo,
  stats,
  isEscrow,
  isSalesStart,
  isFloorPlanEnabled,
  onFloorPlanClick,
  onLinkClick,
  onEscrowLabelClick,
}: IHouseTooltipProps) {
  return (
    <div className={styles['container']}>
      <UIHeading3 data-testid="HouseTooltipName">{name}</UIHeading3>
      {isSalesStart && (
        <div className={styles['sales-start']}>
          <SalesStartLabel />
        </div>
      )}
      <div className={styles['house-info']} data-testid="HouseTooltipInfo">
        {houseInfo.map((item, i) => (
          <UIText2 key={item} color="gray60_100" display="inline">
            {item}
            {i < houseInfo.length - 1 ? ' • ' : ''}
          </UIText2>
        ))}
      </div>

      <div className={styles['labels']}>{isEscrow && <EscrowLabel dark={true} onClick={onEscrowLabelClick} />}</div>

      {stats && <HouseStats {...stats} houseId={houseId} onLinkClick={onLinkClick} />}
      {!stats && (
        <div className={styles['line']}>
          <UIText2>Нет квартир в продаже</UIText2>
        </div>
      )}
      {stats && isFloorPlanEnabled && (
        <div className={styles['floor-plan-button']}>
          <Button theme="fill_secondary" size="XS" fullWidth onClick={onFloorPlanClick}>
            Квартиры на этажах
          </Button>
        </div>
      )}
    </div>
  );
}
